import { createAction } from "@reduxjs/toolkit"
import { Builder } from "."
import { SocketSlice } from "./types"
import { StoppedBroadcastingLocation, UserLocation } from "@nova/schemas"
import { orgUserLocationStore } from "features/user-locations/org-user-location-store"

export const subscribeToOrgUserLocations = createAction<string>("org-user-locations/subscribe")
export const unsubscribeFromOrgUserLocations = createAction<string>(
    "org-user-locations/unsubscribe"
)

export default {
    handlers: (builder: Builder) =>
        builder
            .addCase(subscribeToOrgUserLocations, (_, action, socket) => {
                socket.emit("subscribeToOrgUserLocations", action.payload)
            })
            .addCase(unsubscribeFromOrgUserLocations, (_, action, socket) => {
                orgUserLocationStore.flush()
                socket.emit("unsubscribeFromOrgUserLocations")
            }),
    events: {
        orgUserLocationsSnapshot: () => (payload: UserLocation[]) => {
            orgUserLocationStore.replaceAll(payload)
        },
        orgUserLocationUpdated: () => (payload: UserLocation) => {
            orgUserLocationStore.push(payload)
        },
        orgStoppedBroadcastingLocation: () => (payload: StoppedBroadcastingLocation) => {
            orgUserLocationStore.remove(payload.userId)
        },
    },
} as SocketSlice
